import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '@/design-system/atoms/Button';
import { useBreakpoint } from '@/hooks/useBreakpoint';

import { DesktopProviderCarousel } from './components/DesktopProviderCarousel';
import { MobileProviderCarousel } from './components/MobileProviderCarousel';
import styles from './ProviderCarousel.module.scss';

const ProviderCarousel = ({
    title = 'Find a specialist',
    htmlId = 'doctors',
    cta,
    ctaPreText = 'Want to see more specialists?',
    providers,
    showCta,
    ...props
}) => {
    const breakpoints = useBreakpoint();
    const isMobile = !breakpoints?.large;

    return providers?.length > 0 ? (
        <section className={styles[`provider-carousel`]} id={htmlId} {...props}>
            {isMobile && (
                <MobileProviderCarousel
                    title={title}
                    providers={providers}
                    ctaPreText={ctaPreText}
                    cta={cta}
                    showCta={showCta}
                />
            )}
            {!isMobile && (
                <DesktopProviderCarousel
                    title={title}
                    providers={providers}
                    ctaPreText={ctaPreText}
                    cta={cta}
                    showCta={showCta}
                />
            )}
        </section>
    ) : (
        <></>
    );
};
ProviderCarousel.propTypes = {
    /**
     * title
     */
    title: PropTypes.string,
    /**
     * htmlId for deep link
     */
    htmlId: PropTypes.string,
    /**
     * CTA Pre-text
     */
    ctaPreText: PropTypes.string,
    /**
     * CTA to overwrite dynamically generated CTA
     */
    cta: PropTypes.shape(Button.propTypes),
    /**
     * whether the CTA should be shown
     */
    showCta: PropTypes.bool,
    /**
     * array of providers
     */
    providers: PropTypes.array,
};
export default ProviderCarousel;
